import {
  Field,
  InputAdornment,
  IconButton,
  TextFieldProps,
} from "@digitalreality/ui";
import { ViewIcon, ViewOffIcon } from "@digitalreality/ui-icons";
import React from "react";
import { useState } from "react";

export default function PasswordField(props: TextFieldProps) {
  const [showPassword, setValue] = useState(false);

  const handleMouseDownPassword = (event: MouseEvent) => {
    event.preventDefault();
  };

  return (
    <Field
      {...props}
      type={showPassword ? "text" : "password"}
      InputProps={{
        endAdornment: (
          <InputAdornment position="start">
            <IconButton
              aria-label="toggle password visibility"
              onClick={() => {
                setValue(!showPassword);
              }}
              onMouseDown={() => handleMouseDownPassword}
              edge="end"
            >
              {showPassword ? <ViewOffIcon /> : <ViewIcon />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
}
